<template>
  <b-card title="لیست سوالات" border-variant="dark">
    <b-overlay :show="isLoading">
      <div>
        <b-row>
          <b-col cols="12">
            <language-picker @getLanguage="setLanguage"></language-picker>
          </b-col>
          <b-col cols="12">
            <b-form-group label="جستجوی سوال" label-for="title">
              <b-form-input
                size="sm"
                id="title"
                v-model="debouncedSearchVal"
                trim
                placeholder="جستجو..."
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="سطح سوال" label-for="questionLevel">
              <b-form-select
                @input="setQuestionLevel"
                size="sm"
                id="questionLevel"
                v-model="questionLevel"
                :options="questionLevelEnums"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="questionsList && questionsList.length != 0">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                class="d-flex flex-column"
                v-model="selectedQuestions"
                :aria-describedby="ariaDescribedby"
              >
                <b-form-checkbox
                  class="mt-1"
                  @change="emitSelectedQuestionsArray"
                  v-for="question in questionsList"
                  :key="question.questionId"
                  :value="question"
                >
                  <span dir="auto">
                    {{ question.questionText }}
                  </span>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col
            v-if="questionsList && questionsList.length != 0"
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
        <b-row
          v-if="!questionsList || (questionsList && questionsList.length == 0)"
        >
          <b-col cols="12">
            <p class="text-center">هیچ سوالی جهت نمایش وجود ندارد!</p>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </b-card>
</template>
<script>
export default {
  emits: ["getQuestionsList"],
  props: {
    existingQuestions: {
      // This props is used to filter already added questions
      type: Array,
      required: false,
    },
  },
  mounted() {
    this.getAllQuestions();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllQuestions();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      questionsList: null,
      pageNumber: 1,
      count: 10,
      totalCount: null,
      searchCommand: null,
      selectedQuestions: [],
      languageId: null,
      timeout: null,
      questionLevel: null,
      questionLevelEnums: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "آسان",
          value: 1,
        },
        {
          text: "معمولی",
          value: 2,
        },
        {
          text: "سخت",
          value: 3,
        },
        {
          text: "خیلی سخت",
          value: 4,
        },
      ],
    };
  },
  methods: {
    resetList() {
      this.selectedQuestions = [];
      this.getAllQuestions();
    },
    setQuestionLevel() {
      this.getAllQuestions();
    },
    setLanguage(languageId) {
      this.languageId = languageId;
      this.getAllQuestions();
    },
    emitSelectedQuestionsArray(questions) {
      this.$emit("getQuestionsList", questions);
    },
    async getAllQuestions() {
      try {
        this.isLoading = true;
        let qParams = {
          count: this.count,
          pageNumber: this.pageNumber,
        };
        if (this.searchCommand) {
          qParams["searchCommand"] = this.searchCommand;
        }
        if (this.languageId) {
          qParams["languageId"] = this.languageId;
        }
        if (this.questionLevel) {
          qParams["level"] = this.questionLevel;
        }
        let _this = this;
        let getAllQuestions = new GetAllQuestions(_this);
        getAllQuestions.setRequestParam(qParams);
        await getAllQuestions.fetch((response) => {
          if (response.isSuccess) {
            if (this.existingQuestions) {
              this.questionsList = response.data.questions.filter((question) =>
                this.existingQuestions.every(
                  (oldQuestion) => oldQuestion.questionId != question.questionId
                )
              );
            } else {
              _this.questionsList = response.data.questions;
            }
            _this.totalCount = response.data.questionsCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setSearch(val) {
      this.searchCommand = val;
      this.getAllQuestions();
    },
  },
  computed: {
    debouncedSearchVal: {
      get: function () {
        return this.searchCommand;
      },
      set: function (val) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setSearch(val);
        }, 500);
      },
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckboxGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BFormCheckbox,
    LanguagePicker,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormInput,
  BButton,
  BTable,
  BFormSelect,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetAllQuestions } from "@/libs/Api/Question";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
</script>
